import {
	FeaturesAndCapabilitiesResponsePayloadService,
	VehicleDetails
} from '../../@types/dataTypes';
import _ from 'lodash';
export const isPayloadEmpty = (
	payload: VehicleDetails | FeaturesAndCapabilitiesResponsePayloadService[]
): boolean => {
	return _.isEmpty(payload);
};

export const hasConnectedFeatures = (
	services: FeaturesAndCapabilitiesResponsePayloadService[] | []
): boolean => {
	if (Array.isArray(services)) {
		return services.some((service) => _checkBooleanValues(service));
	} else {
		return false;
	}
};

const _checkBooleanValues = (obj: any): boolean => {
	for (const key in obj) {
		if (typeof obj[key] === `boolean` && obj[key]) {
			return true;
		}
		if (typeof obj[key] === `object` && obj[key] !== null) {
			if (_checkBooleanValues(obj[key])) {
				return true;
			}
		}
	}
	return false;
};
